// Framework and third-party non-ui
import React, { Fragment } from 'react';

// Redux operations and local helpers/utils/modules
import originFields from '../../defaults/PointOfOriginFields.json';
import moment from 'moment';
import { getFieldAliasOverrides, getNameForCategory, getNameForKind, getDomainForCauses } from '../../utils/incidentHelper';
import EditableAcreageTable from '../../components/incidentDetails/EditableAcreageTable';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

// JSON

// CSS

const ReportInfoSection = props => {

  //let isShowingRelatedRecordsDialog = false;

  const getGeneralFireInfoTables = () => {
    const { generalFireInfo } = originFields.reportInfoFields;

    return (
      <div className="report-table-two-col">
        {getTable(generalFireInfo.slice(0, (generalFireInfo.length / 2)))}
        {getTable(generalFireInfo.slice((generalFireInfo.length / 2), generalFireInfo.length))}
      </div>
    )
  }

  const getPerimeterTable = (fieldNames) => {
    const hasAcreages = (props.selectedIncident.incident && props.selectedIncident.incident.perimeterAcreage && props.selectedIncident.incident.perimeterAcreage.AcreageRecords)
    const acreageTable = (hasAcreages) 
    ? 
    (
      <EditableAcreageTable
        mode="read"
        perimeter={props.selectedIncident.perimeter}
        perimeterAcreage={props.selectedIncident.incident.perimeterAcreage}
        isRecalculatingAcres={false}/> 
    ) 
    : "";
    
    const tableRows = fieldNames.map(fieldName => {

      if (props.selectedIncident.perimeter) {
        let fieldValue = props.selectedIncident.perimeter.attributes[fieldName];
        if (fieldName.includes("Date")) {
          fieldValue = moment(fieldValue).format(props.dateFormat);
        }
        return (
          <TableRow key={fieldName}>
            <TableRowColumn className="report-table-fieldname">{fieldName}</TableRowColumn>
            <TableRowColumn className="report-table-fieldvalue">{fieldValue}</TableRowColumn>
          </TableRow>
        );
      } else {
        return "";
      }
    });

    return (
      <div className="report-table">
        <Table selectable={false}>
          <TableBody displayRowCheckbox={false}>
            {tableRows}
          </TableBody>
        </Table>
        {acreageTable}
      </div>
    )
  }

  const getTable = (fieldNames, skipField) => {
    const tableRows = fieldNames.filter(fieldName => fieldName !== skipField)
      .map(fieldName => {


        const fieldInfo = props.fieldInfos.find(info => info.name === fieldName);
        const fieldAlias = getFieldAliasOverrides(fieldInfo);
        
        let fieldValue = props.selectedIncident.incident.attributes[fieldName];

        if (fieldValue && (originFields.dateFieldsWithTypeDouble.includes(fieldName) || fieldInfo.type === "date")) {
          fieldValue = moment(fieldValue).format(props.dateFormat);
        }

        if (fieldValue && fieldName === originFields.incidentTypeCategory) {
          fieldValue = getNameForCategory(fieldValue);
        }

        if (fieldValue && fieldName === originFields.incidentTypeKind) {
          fieldValue = getNameForKind(fieldValue);
        }

        if (fieldName === originFields.fireCauseId || fieldName === originFields.fireCauseGeneralId || fieldName === originFields.fireCauseSpecificId) {
          fieldValue = getDomainForCauses(fieldValue, fieldInfo.domain.codedValues);
        }

        if ((fieldName === "_pointGeometryLatitude" || fieldName === "_pointGeometryLongitude") && fieldValue !== null) {
          fieldValue = parseFloat(fieldValue).toFixed(6);
        }

        if ((fieldValue !== null) && (originFields.trueFalseZeroOnes.includes(fieldName))) {
          fieldValue = (fieldValue === 0 || fieldValue === "0") ? "False" : "True";
        }

        return (
          <TableRow key={fieldName}>
            <TableRowColumn className="report-table-fieldname">{fieldAlias}</TableRowColumn>
            <TableRowColumn className="report-table-fieldvalue">{fieldValue}</TableRowColumn>
          </TableRow>
        );
      });

    return (
      <div className="report-table">
        <Table
          selectable={false}>
          <TableBody
            displayRowCheckbox={false}>
            {tableRows}
          </TableBody>
        </Table>
      </div>
    )
  }

  const { incident, pointOfOrigin, sizeAndPerimeter, perimeter, chronology, complexityManagement, siteDescriptors, outcomes, fireCause, miscellaneous } = originFields.reportInfoFields;

  return (
    <Fragment>
      <div className="report-info-section">
        <div className="report-table-section">
          <h3>Fire Summary</h3>
          {getGeneralFireInfoTables()}
        </div>
        <div className="report-table-col-container">
          <div className="report-table-col">

            <div className="report-table-section">
              <h3>Incident</h3>
              {getTable(incident)}
            </div>

          </div>

          <div className="report-table-col">

            <div className="report-table-section">
              <h3>Complexity & Management</h3>
              {getTable(complexityManagement)}
            </div>

            <div className="report-table-section">
              <h3>Site Descriptors</h3>
              {getTable(siteDescriptors)}
            </div>

            <div className="report-table-section">
              <h3>Outcomes</h3>
              {getTable(outcomes)}
            </div>
          </div>

        </div>
      </div>

      <div className="narrative-container">
        <div className="report-info-section">
          <div className="report-table-col-container">
            <div className="report-table-col">

              <div className="report-table-section">
                <h3>Point of Origin</h3>
                {getTable(pointOfOrigin)}
              </div>

              <div className="report-table-section">
                <h3>Size</h3>
                {getTable(sizeAndPerimeter)}
              </div>

            </div>
            <div className="report-table-col">

              <div className="report-table-section">
                <h3>Fire Cause</h3>
                {getTable(fireCause)}
              </div>

              <div className="report-table-section">
                <h3>Miscellaneous</h3>
                {getTable(miscellaneous, originFields.report)}
              </div>

              <div className="report-table-section">
                <h3>Chronology</h3>
                {getTable(chronology)}
              </div>

            </div>


          </div>
        </div>
      </div>

                   
      <div className="report-table">
                <h3>Perimeter</h3>
                {getPerimeterTable(perimeter)}
              </div>
    </Fragment>
  );
}

ReportInfoSection.propTypes = {};

ReportInfoSection.defaultProps = {};

export default ReportInfoSection;
